import { Resource } from 'react-admin'
import { BankAccountEditDialog, BankAccountList } from './bank_account'
import { AssuranceList } from './assurance'
import { SyndicContractsList } from './syndic_contracts'
import { LotsEditDialog, LotsList } from './lots'
import { AccessEditDialog, AccessList } from './access'
import { JanitorEditDialog, JanitorList } from './janitor'
import { CoownershipRulesList } from './coownership_rules'
import { AgList } from './ag'
import { VisitRemainingList } from './visits_remaining'
import { VisitsGlobalList } from './visits_global'

const section_name = 'compliance'

export const RoutesCompliance = (generateIconUrl) => [
  <Resource
    name={`${section_name}/bank_account`}
    options={{
      label: 'resources.compliance.bank_account',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    edit={BankAccountEditDialog}
    list={BankAccountList}
  />,
  <Resource
    name={`${section_name}/assurance`}
    options={{
      label: 'resources.compliance.assurance',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    list={AssuranceList}
  />,
  <Resource
    name={`${section_name}/syndic_contracts`}
    options={{
      label: 'resources.compliance.syndic_contracts',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    list={SyndicContractsList}
  />,
  <Resource
    name={`${section_name}/lots`}
    options={{
      label: 'resources.compliance.lots',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    edit={LotsEditDialog}
    list={LotsList}
  />,
  <Resource
    name={`${section_name}/access`}
    options={{
      label: 'resources.compliance.access',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    edit={AccessEditDialog}
    list={AccessList}
  />,
  <Resource
    name={`${section_name}/janitor`}
    options={{
      label: 'resources.compliance.janitor',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    edit={JanitorEditDialog}
    list={JanitorList}
  />,
  <Resource
    name={`${section_name}/coownership_rules`}
    options={{
      label: 'resources.compliance.coownership_rules',
      subMenu: {
        name: section_name,
        icon: generateIconUrl('racingflags'),
      },
    }}
    list={CoownershipRulesList}
  />,
  <Resource
    name={`${section_name}/ag`}
    options={{
      label: 'resources.compliance.ag',
      subMenu: {
        name: section_name,
      },
    }}
    list={AgList}
  />,
  <Resource
    name={`${section_name}/visits_remaining`}
    options={{
      label: 'resources.compliance.visits_remaining',
      subMenu: {
        name: section_name,
      },
    }}
    list={VisitRemainingList}
  />,
  <Resource
    name={`${section_name}/visits_global`}
    options={{
      label: 'resources.compliance.visits_global',
      subMenu: {
        name: section_name,
      },
    }}
    list={VisitsGlobalList}
  />,
]
